import { FC, useEffect, useMemo, useState } from 'react';

import styled from '@emotion/styled';
import { CandidatePersonalDetails } from 'store/candidate/types';
import { fileDownload } from 'core/fileDownload';
import { selectSelectedCountryId } from 'store/country/countrySlice';
import { useAppSelector } from 'store';
import { useLazyGetRegistrationsReportQuery } from 'store/my-registrations/myRegistrationsAPI';

import { Button } from '@britishcouncil/react-solas';
import { BcSelect, Divider } from '@britishcouncil/react-solas-ors3';

export const CandidateReport: FC<{
  candidate: CandidatePersonalDetails & { sessions: { id: number; name: string }[] };
  loading: boolean;
}> = ({ candidate, loading }) => {
  const [selectedSession, setSelectedSession] = useState<number | undefined>(undefined);
  const countryId = useAppSelector(selectSelectedCountryId);
  const [getRegistrationsReport, { data, isFetching: isReportLoading }] = useLazyGetRegistrationsReportQuery();

  const options = useMemo(
    () => candidate.sessions.map((x) => ({ value: `${x.id}`, name: x.name })),
    [candidate.sessions]
  );

  const downloadReport = () => {
    if (selectedSession && countryId) {
      getRegistrationsReport({ candidateId: candidate.id, sessionId: selectedSession, countryId: Number(countryId) });
    }
  };

  useEffect(() => {
    if (data) {
      fileDownload(data.file, data.headers);
    }
  }, [data]);

  return (
    <div>
      <h3>
        {candidate.otherNames} {candidate.familyName}
      </h3>
      <div>
        <label>Select session</label>
        <BcSelect
          isLoading={loading}
          options={options}
          value={`${selectedSession}`}
          onChange={(value) => setSelectedSession(Number(value))}
          placeholder="Select session"
        />
      </div>
      <PrintBtnBox>
        <Button disabled={!selectedSession} onClick={downloadReport} loading={isReportLoading}>
          Print full report
        </Button>
      </PrintBtnBox>
      <Divider />
    </div>
  );
};

const PrintBtnBox = styled.div`
  text-align: right;
  padding-top: 10px;
`;
